module.exports = __webpack_public_path__ + "static/media/blue-card.3ede1f8f.png";